import React from 'react'

/**
 * Shared gradient + filter defs for the World map.
 *
 * Severity gradients (sev-ok/warn/crit) fill studio diamonds and client hexes.
 * Marker depth uses a compact drop shadow. Theme-neutral RGBA; hoisted so defs
 * aren't rebuilt each render.
 */
export function SvgGradients() {
  return (
    <defs>
      <linearGradient id="sev-ok" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%"   stopColor="rgba(52,201,95,0.85)" />
        <stop offset="100%" stopColor="rgba(52,201,95,0.45)" />
      </linearGradient>
      <linearGradient id="sev-warn" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%"   stopColor="rgba(245,166,35,0.85)" />
        <stop offset="100%" stopColor="rgba(245,166,35,0.45)" />
      </linearGradient>
      <linearGradient id="sev-crit" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%"   stopColor="rgba(232,64,64,0.85)" />
        <stop offset="100%" stopColor="rgba(232,64,64,0.45)" />
      </linearGradient>

      <filter id="marker-shadow" x="-60%" y="-60%" width="220%" height="220%">
        <feDropShadow dx="0" dy="1" stdDeviation="1.3" floodColor="rgba(0,0,0,0.45)" />
      </filter>
    </defs>
  )
}
